import { Link } from 'react-router';

const productLinks = [
  { to: '/features', label: 'Features' },
  { to: '/contact', label: 'Contact' },
];

const resourceLinks = [
  { to: '/ai-dlp', label: 'AI DLP Guide' },
  { to: '/shadow-ai', label: 'Shadow AI' },
  { to: '/stop-chatgpt-data-leaks', label: 'Stop ChatGPT Leaks' },
  { to: '/ai-dlp-vs-traditional-dlp', label: 'AI DLP vs Traditional DLP' },
];

const legalLinks = [
  { to: '#', label: 'Privacy Policy' },
  { to: '#', label: 'Terms of Service' },
  { to: '#', label: 'Security' },
];

export function Footer() {
  return (
    <footer className="border-t border-border bg-surface px-6 py-16">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-12 md:grid-cols-4">
          {/* Brand column */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 text-lg font-bold tracking-tight">
              <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-red-accent">
                <svg width="20" height="14" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 2L24 6.5V17.5L16 22L8 17.5V6.5L16 2Z" stroke="#F0F0F5" strokeWidth="1.3" fill="#0A0A0F" />
                  <path d="M10 7L4 4" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
                  <path d="M9 10L3 10" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
                  <path d="M9 14L3 14" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
                  <path d="M10 17L4 20" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
                  <path d="M22 7L28 4" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
                  <path d="M23 10L29 10" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
                  <path d="M23 14L29 14" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
                  <path d="M22 17L28 20" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
                  <path d="M16 8L20 10.5V15.5L16 18L12 15.5V10.5L16 8Z" fill="#F2555A" />
                  <circle cx="16" cy="12" r="1.5" fill="#E5484D" />
                </svg>
              </span>
              <span className="text-text-primary">Redbax</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-text-secondary">
              Endpoint protection that keeps sensitive data from leaking into AI tools.
            </p>
          </div>

          {/* Product */}
          <div>
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-text-secondary">
              Product
            </h3>
            <ul className="space-y-3">
              {productLinks.map(({ to, label }) => (
                <li key={label}>
                  <Link
                    to={to}
                    className="text-sm text-text-secondary transition-colors hover:text-text-primary"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-text-secondary">
              Resources
            </h3>
            <ul className="space-y-3">
              {resourceLinks.map(({ to, label }) => (
                <li key={label}>
                  <Link
                    to={to}
                    className="text-sm text-text-secondary transition-colors hover:text-text-primary"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-text-secondary">
              Legal
            </h3>
            <ul className="space-y-3">
              {legalLinks.map(({ to, label }) => (
                <li key={label}>
                  <Link
                    to={to}
                    className="text-sm text-text-secondary transition-colors hover:text-text-primary"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-border pt-8">
          <p className="text-center text-sm text-text-secondary">
            &copy; {new Date().getFullYear()} Redbax Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
